import { palette, shape, typography } from "@src/core/styles";
import styled from "styled-components";
import type { BadgeProps, CardImageProps } from "./card.types";

export const StyledCard = styled.div`
  background-color: ${palette.colors.surface_container};
  padding: 16px;
  border-radius: ${shape.rounding.L};

  & button {
    text-transform: none !important;
    width: 100%;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const CardBody = styled.div``;

export const CardImage = styled.div<CardImageProps>`
  width: 100%;
  height: 164px;
  border-radius: ${shape.rounding.XXL};
  padding: 0 24px;
  background-color: ${palette.colors.white_main};
  background-image: ${({ url }) => `url(${url})`};
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  margin-bottom: 16px;
`;

export const CardContent = styled.div`
  & svg {
    width: 12px;
    height: 9px;
    margin: 0 6px;
  }
  margin-bottom: 24px;
`;

export const CardContentItem = styled.div`
  display: flex;
  align-items: center;
`;

export const CardTitle = styled.div`
  ${typography.label_large};
`;

export const Badge = styled.div<BadgeProps>`
  ${typography.label_large};
  border-radius: ${shape.rounding.XXXL};
  padding: 0 12px;
  background-color: ${({ badgeColor }) => {
    switch (badgeColor) {
      case "blue":
        return `${palette.colors.tertiary_container}`;
      case "green":
        return `${palette.colors.green90}`;
    }
  }};
`;

export const Period = styled.div`
  ${typography.title_large};
  margin-bottom: 16px;
`;
